import { Box } from '@mui/material'
import * as React from 'react'

export function Checkmark() {
  return (
    <Box
      padding="3px 7px 10px 7px"
      style={{ backgroundColor: 'lightGreen' }}
      color="darkGreen"
      borderRadius="50px"
      width="12px"
      height="12px"
    >
      <strong>{'✓'}</strong>
    </Box>
  )
}
